import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const DocumentIcon = forwardRef<SVGSVGElement, IconProps>(function DocumentIcon(
  { color = '', height = 12, width = 12, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.6879 1.6879C1.19372 2.18207 0.923077 2.99937 0.923077 4.33846V7.66154C0.923077 9.00063 1.19372 9.81793 1.6879 10.3121C2.18207 10.8063 2.99937 11.0769 4.33846 11.0769H7.66154C9.00063 11.0769 9.81793 10.8063 10.3121 10.3121C10.8063 9.81793 11.0769 9.00063 11.0769 7.66154V5.35385H9.32308C8.46674 5.35385 7.74898 5.21708 7.26595 4.73405C6.78292 4.25102 6.64615 3.53326 6.64615 2.67692V0.923077H4.33846C2.99937 0.923077 2.18207 1.19372 1.6879 1.6879ZM7.56923 1.57579L10.4242 4.43077H9.32308C8.51788 4.43077 8.12794 4.29062 7.91866 4.08134C7.70939 3.87206 7.56923 3.48212 7.56923 2.67692V1.57579ZM1.03518 1.03518C1.78716 0.283201 2.90832 0 4.33846 0H7.10769C7.2301 0 7.34749 0.0486262 7.43405 0.135182L11.8648 4.56595C11.9514 4.65251 12 4.7699 12 4.89231V7.66154C12 9.09167 11.7168 10.2128 10.9648 10.9648C10.2128 11.7168 9.09167 12 7.66154 12H4.33846C2.90832 12 1.78716 11.7168 1.03518 10.9648C0.283201 10.2128 0 9.09167 0 7.66154V4.33846C0 2.90832 0.283201 1.78716 1.03518 1.03518Z"
        fill={color || 'currentColor'}
      />
    </SvgStyled>
  );
});
